<template>
<base-manual-audit-view
  v-if="isShow"
  :site="site"
  :audit-site-device="auditSiteDevice"
  :conditions="conditions"
  :stage="stage"
  :max-audit-stage="maxAuditStage"
  :selected-factor-ids="selectedFactorIds"
  :audit-rule-categories="auditRuleCategories"
  :filter-device-error-factor-ids="filterDeviceErrorFactorIds"
  :has-audit-btn="hasAuditBtn"
  :data-times="dataTimes"
  :data-list="unitConverterDataList"
  :number-to-c-n="numberToCN"
  :show-mini-chart.sync="showMiniChart"
  :on-back-btn-click="onBackBtnClick"
  :on-audit-time-changed="onAuditTimeChanged"
  :on-month-audit-btn-click="onMonthAuditBtnClick"
  :on-batch-process-btn-click="onBatchProcessBtnClick"
  :on-audit-submit-btn-click="onAuditSubmitBtnClick"
  :on-month-audit-submit-btn-click="onMonthAuditSubmitBtnClick"
  :on-back-re-audit-btn-click="onBackReAuditBtnClick"
  compareChartWidth="430px"
>
  <template #displayChart>
    <div style="display:flex;flex-direction:column;width:100%;height:100%;padding: 0;border:1px solid #E4E7ED;background-color:#ffffff;overflow:auto;">
      <el-tabs v-if="tabOpts.length > 1" v-model="tabActiveName" type="card" @tab-click="tabChange">
        <el-tab-pane
          v-for="tabOpt in tabOpts"
          :key="tabOpt.name"
          :label="tabOpt.label"
          :name="tabOpt.name"
        />
      </el-tabs>

      <audit-oc-ec-device-compare-chart
        v-if="tabActiveName === 'ocec'"
        :site="site"
        :audit-site-device="auditSiteDevice"
        :audit-time="conditions.auditTime"
        :conditions="conditions"
        style="flex:1;min-height:0;overflow:auto;"
      />

      <audit-key-parameter-chart
        v-else
        :query="statusQuery"
        :data="statusData"
        :importance-device-status-map="importanceDeviceStatusMap"
        style="flex:1;min-height:0;overflow:auto;"
      />
    </div>
  </template>
</base-manual-audit-view>
</template>

<script>
import BaseAuditDevice from '../BaseAuditDevice'
import BaseManualAuditView from '../BaseManualAuditView'

import {
  AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED,
  PROCESS_PANEL_SAVE,
  SHOW_BATCH_PROCESS_PANEL
} from '../EventKeys'
import AuditOcEcDeviceCompareChart from './AuditOcEcDeviceCompareChart'
import AuditKeyParameterChart from './AuditKeyParameterChart'

export default {
  name: 'AuditOcEcDevice',
  extends: BaseAuditDevice,
  components: {AuditOcEcDeviceCompareChart, BaseManualAuditView, AuditKeyParameterChart},
  data () {
    return {
      showMiniChart: 'miniChart',
      tabActiveName: 'ocec',
      statusQuery: {},
      statusData: []
    }
  },
  computed: {
    loadAuditRuleCategories: () => true,
    siteDeviceCategory: () => process.env.OCEC_DEVICE_CATEGORY,
    unitConverterDataList () {
      let dataList = JSON.parse(JSON.stringify(this.dataList))
      let {$unitConverter} = this
      if (dataList.length === 0) {
        return []
      }

      let temp = dataList[0].data
      dataList.forEach(item => {
        let {molecular, unit, stdUnit, decimalNum, data} = item
        item.defectData = []

        data.forEach(dataItem => {
          let {value} = dataItem
          dataItem.value = (isNaN(value) || value === null) ? NaN : Number($unitConverter(value, stdUnit, unit, molecular).toFixed(decimalNum))
          if (isNaN(dataItem.value)) {
            item.defectData.push(dataItem)
          }
        })

        temp = this.getSame(temp, item.defectData)
      })

      return dataList.map(el => {
        return {
          ...el,
          defectData: temp
        }
      })
    },
    missingDataList () {
      return this.unitConverterDataList.filter(data => data.data.some(data => data.id === null))
    },
    filterDeviceErrorFactorIds () {
      let data = this.dataList.map(el => el.data).flat()
      return data.filter(el => el.isAlarm).map(el => el.factorId)
    },
    tabOpts () {
      let tabOpts = [{
        name: 'ocec',
        label: 'PM2.5和OCEC'
      }]
      let {auditSiteDevice, importanceDevicesMap} = this
      if (this.importanceDeviceStatus.length > 0 && importanceDevicesMap[auditSiteDevice.id]) {
        tabOpts.unshift({
          name: 'keyParameter',
          label: '关键参数'
        })
      }

      return tabOpts
    }
  },
  methods: {
    tabChange ({name}) {
      if (name === 'keyParameter') {
        let {auditSiteDevice, conditions: {beginTime, endTime}, query: {siteId}, importanceDevicesMap} = this
        let queryData = {
          siteIds: [siteId],
          beginTime: new Date(beginTime).format('YYYY/MM/DD 00:00:00'),
          endTime: new Date(endTime).format('YYYY/MM/DD 23:59:59'),
          statusIds: importanceDevicesMap[auditSiteDevice.id].map(el => el.deviceStatusId)
        }

        this.changeLoadStatus(true)
        this.$api.StatusData.getKeyParameter(queryData).then(data => {
          this.statusData = Object.freeze(data)
          this.statusQuery = queryData
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      }
    },
    getSame (arr1, arr2) {
      return [...new Set(arr1)].filter(item => arr2.find(el => el.dataTime === item.dataTime))
    },
    formatDataList (dataList) {
      // const startHour = process.env.AUDIT_BEGIN_HOUR

      // let {conditions: {auditTime},siteDeviceFactors, factorMap} = this
      let {conditions: {beginTime, endTime}, siteDeviceFactors, factorMap} = this
      // let date = new Date(auditTime)

      let dataMap = dataList.reduce((map, data) => {
        let {factorId} = data
        let factorData = map[factorId]

        if (!factorData) {
          factorData = map[factorId] = {}
        }

        factorData[data.dataTime] = data

        return map
      }, {})

      let dataTimes

      if (this.auditSiteDevice.deviceId === 'tekran2537x') {
        dataTimes = Object.values(dataList.reduce((map, data) => {
          let date = new Date(data.dataTime)
          map[date.getTime()] = date
          return map
        }, {}))
      } else {
        // let dataFrequency = this.auditSiteDevice.dataFrequency || 60
        // date.setHours(startHour, 0, 0)
        // date.setMinutes(date.getMinutes() - dataFrequency)
        // dataTimes = Object.freeze(new Array(1440 / dataFrequency).fill(0).map((n, index) => {
        //   date.setMinutes(date.getMinutes() + dataFrequency)
        //   return new Date(date)
        // }))
        let beginTS = new Date(beginTime).getTime()
        let endTS = new Date(endTime).getTime()
        let tsStep = 60 * 60000
        let temp = []
        for (let ts = beginTS; ts <= endTS; ts += tsStep) {
          temp.push(new Date(ts))
        }
        dataTimes = Object.freeze(temp)
      }

      this.dataTimes = dataTimes
      let dataTimeStrList = dataTimes.map(dataTime => dataTime.format('YYYY/MM/DD HH:mm:ss'))

      this.dataList = Object.freeze(siteDeviceFactors.filter(siteDeviceFactor => factorMap[siteDeviceFactor.factorId]).map(siteDeviceFactor => {
        let {factorId} = siteDeviceFactor
        let factor = factorMap[factorId]
        let dataFactorMap = dataMap[factorId] || {}

        return Object.freeze({
          id: factorId,
          name: factor.displayName,
          unit: factor.stdUnit,
          stdUnit: factor.stdUnit,
          displayUnit: factor.displayUnit,
          parentId: factor.parentId,
          decimalNum: factor.decimalNum,
          molecular: factor.molecular,
          data: Object.freeze(dataTimeStrList.map((dataTimeStr, index) => {
            let data = dataFactorMap[dataTimeStr] || {}
            let {dasValue, autoValue} = data

            let newAutoFlag = data.autoFlag || null

            if (data.autoFlag === 'N' && data.isAlarm) {
              newAutoFlag = 'DERROR'
            } else if (data.autoFlag && data.isAlarm) {
              newAutoFlag += '|DERROR'
            } else if (data.autoFlag === '' && data.isAlarm) {
              newAutoFlag = 'DERROR'
            }

            return Object.freeze({
              id: data.id || null,
              factorId: factorId,
              dataTime: dataTimeStr,
              dasValue: Number.isFinite(dasValue) ? dasValue : NaN,
              dasFlag: data.dasFlag || null,
              value: Number.isFinite(autoValue) ? autoValue : NaN,
              autoFlag: newAutoFlag,
              auditFlag: data.auditFlag || null,
              isAlarm: data.isAlarm || null,
              auditComment: data.auditComment || null
            })
          }))
        })
      }))
    },
    onBatchProcessBtnClick () {
      this.$eventBus.emit(SHOW_BATCH_PROCESS_PANEL, this.selectedFactorIds)
    },
    onAuditSubmitBtnClick () {
      // let {missingDataList} = this
      // let dataMissingFlag = missingDataList.length > 0
      let noData = this.auditSiteDevice.dataHarvestRates ? this.auditSiteDevice.dataHarvestRates.filter(el => el.harvestRate === 0) : []
      if (noData.length > 0) {
        let {conditions: {auditTime}} = this
        let deviceId = this.auditSiteDevice.id
        this.$api.NoData.getNoData(auditTime, deviceId).then(data => {
          if (data.length === 0) {
            return this.$alert('请处理缺失数据', '数据缺失提示', {
              confirmButtonText: '确定',
              callback: action => {
                return false
              }
            })
          }
        }).catch(console.error)
      }

      // if (dataMissingFlag) {
      //   // return this.$notify({
      //   //   title: '错误',
      //   //   message: '数据有缺失, 不能提交审核',
      //   //   type: 'warning',
      //   //   position: 'bottom-right'
      //   // })
      //   return this.$prompt('数据缺失原由', '数据缺失提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     inputValue: this.remark || '',
      //     inputPattern: /[^\s]+/,
      //     inputErrorMessage: '请输入缺失原由'
      //   }).then(({value}) => {
      //     this.remark = value
      //     this.afterDataMissingJudge()
      //   }).catch(() => {})
      // }

      this.afterDataMissingJudge()
    },
    afterDataMissingJudge () {
      let unProcesses = this.unitConverterDataList.map(data => ({
        id: data.id,
        name: data.name,
        count: data.data.reduce((count, data) => count + ((data.id && data.autoFlag !== 'N' && !data.auditFlag) | 0), 0)
      })).filter(data => data.count > 0)

      if (unProcesses.length > 0) {
        const h = this.$createElement

        return this.$msgbox({
          title: '消息',
          confirmButtonText: '确定',
          message: h('section', {
            style: 'margin:-10px 0;'
          }, unProcesses.reduce((list, data) => {
            list.push(h('div', {
              style: 'line-height:1.7'
            }, [
              h('span', `${data.name}：共计`),
              h('span', {
                style: 'color:#409EFF;'
              }, ` ${data.count} `),
              h('span', '个')
            ]))

            return list
          }, [
            h('div', {
              style: 'margin-bottom:.5em;font-weight:bolder;'
            }, '您还有以下异常还未审核:')
          ]))
        }).then(() => {}).catch(() => {})
      }

      this.submitAudit()
    },
    onAuditMainGridFactorIdsChanged (factorIds) {
      this.selectedFactorIds = factorIds
    },
    onProcessPanelSave () {
      this.getAuditDataBySiteDevice()
    }
  },
  created () {
    let {$eventBus} = this
    $eventBus.on(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, this.onAuditMainGridFactorIdsChanged)
    $eventBus.on(PROCESS_PANEL_SAVE, this.onProcessPanelSave)
  },
  beforeDestroy () {
    let {$eventBus} = this
    $eventBus.off(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, this.onAuditMainGridFactorIdsChanged)
    $eventBus.off(PROCESS_PANEL_SAVE, this.onProcessPanelSave)
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditOcEcDevice.vue